import { createFeatureSelector, createSelector } from '@ngrx/store';
import { weightManagementFeatureKey } from '../weight-management-feature-key';
import { WeightManagementState } from '../weight-management.state';

const selectState = createFeatureSelector<WeightManagementState>(weightManagementFeatureKey);
/**
 * Select patient target program
 */
export const selectFollowUpAction = createSelector(selectState, (state) => state.followUpAction);
/**
 * Select patient minimal bcs authorized
 */
export const selectMinimalBcs = createSelector(selectState, (state) => state.minimalBcs);
